import React, {
  FunctionComponent,
} from 'react';

import {
  ActionsDropdownProps,
  ActionsDropdownTransitions,
  DropdownVariants
} from '@components/library/dropdown';
import BaseDropdown from '@components/library/dropdown/base/BaseDropdown';
import styleClassNames from './actions-dropdown.module.scss';

export const ActionsDropdown: FunctionComponent<ActionsDropdownProps> = (
  props
) => {
  const {
    anchorElement,
    anchorElementLabel,
    dropdownTransition = ActionsDropdownTransitions.FadeInTranslate,
  } = props;
  const defaultAnchorElement = (
    <span aria-hidden className={`bff-ellipsis ${styleClassNames.ellipsis}`} />
  );

  const baseProps = {
    ...props,
    anchorElement: anchorElement || defaultAnchorElement,
    anchorElementLabel,
    dropdownTransition,
    styleClassNames,
    variantName: DropdownVariants.Actions,
  };

  return <BaseDropdown {...baseProps} />;
};
